export const LINK_COLLECTION_TEMPLATE_STORAGE = 'storage';
export const LINK_COLLECTION_TEMPLATE_GALLERY = 'gallery';
export const LINK_COLLECTION_TEMPLATE_TEAM = 'team';
export const LINK_COLLECTION_TEMPLATE_CUSTOM = 'custom';
